import { useEffect, useState } from "react";
import "./CookieBanner.css";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const acknowledged = localStorage.getItem("cookies-accepted");

    if (!acknowledged) {
      setVisible(true);
    }
  }, []);

  const dismissNotice = () => {
    localStorage.setItem("cookies-accepted", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <p>
        Este sitio utiliza únicamente almacenamiento y tecnologías técnicas
        necesarias para su funcionamiento.{" "}
        <a href="/privacidad">Más información</a>
      </p>

      <button type="button" onClick={dismissNotice}>
        Entendido
      </button>
    </div>
  );
}
